/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style5 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style6 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style7 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style8 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _config = require('util/config');

var _tool = require('util/tool');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
// import { getToken } from 

var _ref = (0, _jsx3.default)(FormItem, {}, void 0, (0, _jsx3.default)('h3', {}, void 0, '\u767B\u5F55'));

var _ref2 = (0, _jsx3.default)(_input2.default, {
  placeholder: '\u8BF7\u8F93\u5165\u7528\u6237\u540D'
});

var _ref3 = (0, _jsx3.default)(_input2.default, {
  type: 'password',
  placeholder: '\u8BF7\u8F93\u5165\u5BC6\u7801'
});

var _ref4 = (0, _jsx3.default)(_button2.default, {
  type: 'primary',
  className: 'create-form-button'
}, void 0, '+\u521B\u5EFA\u4EA7\u54C1');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          var userName = values.userName,
              password = values.password;

          (0, _tool.http)(_config.apiJson.doLogin, {
            userName: userName,
            password: password
          }).then(function (res) {
            if (res) {
              _message2.default.success('\u767B\u5F55\u6210\u529F');
              _this.props.saveUser({ token: res.token, name: res.userName });
              _this.props.router.push({
                pathname: '/'
              });
            }
          }).catch(function (res) {
            var msg = !res.errmsg ? '' + res : res.errmsg;
            _message2.default.error(msg);
          });
        }
      });
    };

    _this.state = {
      status: 1
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //获取数据
      window.localStorage.removeItem('userName');
      window.localStorage.removeItem('token');
    }
  }, {
    key: 'render',
    value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;

      return (0, _jsx3.default)('div', {
        className: 'login'
      }, void 0, this.state.status == 1 ? (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('div', {
        className: 'login-title'
      }, void 0, (0, _jsx3.default)('img', {
        src: require('./logo.png'),
        alt: ''
      })), (0, _jsx3.default)(_form2.default, {
        onSubmit: this.handleSubmit.bind(this),
        className: 'login-form'
      }, void 0, _ref, (0, _jsx3.default)(FormItem, {}, void 0, getFieldDecorator('userName', {
        rules: [{ required: true, message: '请输入用户名!' }]
      })(_ref2)), (0, _jsx3.default)(FormItem, {}, void 0, getFieldDecorator('password', {
        rules: [{ required: true, message: '请输入密码!' }]
      })(_ref3)), (0, _jsx3.default)(FormItem, {}, void 0, (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        className: 'login-form-button',
        onClick: this.handleSubmit
      }, void 0, '\u767B\u5F55')))) : _ref4);
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: 'login', //应用关联使用的redux
  component: _form2.default.create()(Main), //接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/login/index.jsx
// module id = 678
// module chunks = 0